import { render, staticRenderFns } from "./VerAnexos.vue?vue&type=template&id=004ab208&"
import script from "./VerAnexos.vue?vue&type=script&lang=js&"
export * from "./VerAnexos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports